import Resource from '../../../api/resources/Resource'
import { PAGINATOR_BIG_PAGE_SIZE } from '@/shared/services/services-constants'

class LaboratoryDyncamicServices extends Resource {
    constructor() {
        super()
        this.source = null
    }
    cancelAxiosCall() {
        if (this.source) {
            this.source.cancel('cancelError')
            this.source = null
        }
    }
    async paginator(filterModel, params, laboratoryId, url) {
        this.source = this.axios.CancelToken.source()

        const response =
            await this.axios.put(
                `/laboratory/laboratories/${laboratoryId}/cases/samples/${url}`,
                filterModel,
                { params, cancelToken: this.source.token })
        return response.data
    }
    // TODO: Israel --> sectionId no se usa? preguntar a alguien de front
    async applyAction(laboratoryId, sectionId, url, entityIdentifiers) {
        const response = await this.axios.put(`/laboratory/laboratories/${laboratoryId}/cases/samples/${url}`, { entityIdentifiers: entityIdentifiers })
        return response.data
    }
    async applyNonBatchAction(laboratoryId, caseId, sampleId, url) {
        const response = await this.axios.put(`/laboratory/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/${url}`)
        return response.data
    }
    async applyDevice(laboratoryId, deviceSelectedId, operationCodes, overwrite, url, entityIdentifiers) {
        const params = {
            deviceSelectedId,
            operationCodes,
            overwrite
        }
        const response = await this.axios.put(`/laboratory/laboratories/${laboratoryId}/cases/samples/${url}/setDevice`, { entityIdentifiers: entityIdentifiers }, { params })
        return response.data
    }
    async getSubportions(laboratoryId, caseId, sampleId, portionId) {
        const response = await this.axios.get(`laboratory/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions`)
        return response.data
    }
    async getSubportionsPendingSlide(laboratoryId, caseId, sampleId, portionId, sectionIds) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sectionIds
        }
        const response = await this.axios.put(
            `laboratory/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/pendingSlide`,
            null,
            { params })
        return response.data
    }
    async exportTo(laboratoryId, sectionLabel, filterModel, sortModel, columns, selectedIds, url, sectionIds, exportType) {
        const params = {
            page: 0,
            size: PAGINATOR_BIG_PAGE_SIZE,
            sort: sortModel,
            sectionIds,
            exportType
        }
        return this.axios.put(
            `/laboratory/laboratories/${laboratoryId}/cases/samples/${url}/exportToPdf`,
            { sectionLabel, filterModel, columns, entityIdentifiersRequest: { entityIdentifiers: selectedIds } },
            { params, responseType: 'arraybuffer' })
    }
    async getPortionsSearchByLabel(laboratoryId, portionLabel, sectionIds) {
        const params = {
            portionLabel: portionLabel,
            sectionIds: sectionIds
        }
        const response = await this.axios.get(`laboratory/laboratories/${laboratoryId}/cases/samples/portions/searchByLabel`, { params })
        return response.data
    }
    async getSubportionsSearchByLabel(laboratoryId, subportionLabel, sectionIds) {
        const params = {
            subportionLabel: subportionLabel,
            sectionIds: sectionIds
        }
        const response = await this.axios.get(`laboratory/laboratories/${laboratoryId}/cases/samples/portions/subportions/searchByLabel`, { params })
        return response.data
    }
    async getSamplesSearchByLabel(laboratoryId, sampleLabel, sectionIds) {
        const params = {
            sampleLabel: sampleLabel,
            sectionIds: sectionIds
        }
        const response = await this.axios.get(`laboratory/laboratories/${laboratoryId}/cases/samples/searchByLabel`, { params })
        return response.data
    }
    async discardSubportions(laboratoryId, params) {
        const response = await this.axios.put(`/laboratory/laboratories/${laboratoryId}/cases/samples/portions/subportions/discard`, { entityIdentifiers: params })
        return response.data
    }
    async patchPortion(laboratoryId, caseId, sampleId, portionId, portionPatch) {
        const response = await this.axios.patch(`/laboratory/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}`, portionPatch)
        return response.data
    }
    async patchSubportion(laboratoryId, caseId, sampleId, portionId, subportionId, subportionPatch) {
        const response = await this.axios.patch(`/laboratory/laboratories/${laboratoryId}/cases/${caseId}/samples/${sampleId}/portions/${portionId}/subportions/${subportionId}`, subportionPatch)
        return response.data
    }
}

export default new LaboratoryDyncamicServices()
